import config from '../_config/config';

const getDashboard = (newCustomerDays = 1) => {
    return new Promise((res, rej) => {
        let xhr = new XMLHttpRequest();

        xhr.addEventListener("load", () => {
            if (xhr.responseText === "") return null;
            res(JSON.parse(xhr.responseText));
        });

        xhr.addEventListener("error", (err) => {
            rej(err.message);
        });

        xhr.open("GET", `${config.API_HOST}/dashboard?newCustomerDays=${newCustomerDays}`);
        xhr.setRequestHeader("content-type", "application/json");
        xhr.setRequestHeader("Authorization", `Bearer ${localStorage.getItem("token")}`);
        xhr.send();
    });
};

const downloadDashboardCsv = (endpoint, filename, from, to) => {
    const params = new URLSearchParams({ from, to }).toString();
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.open("GET", `${config.API_HOST}/dashboard/${endpoint}?${params}`);
    xhr.setRequestHeader("Authorization", `Bearer ${localStorage.getItem("token")}`);
    xhr.onload = () => {
        const url = URL.createObjectURL(xhr.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    xhr.send();
};

export {
    getDashboard,
    downloadDashboardCsv,
}